@if (!isDiscussionContent) {
  <h3 class="small h6">REPLIES TO YOUR POSTS</h3>
}
@if (postAndReplySearchResults && !loadingData) {
  <ul class="mb-3 list-group">
    @for (activity of postAndReplySearchResults; track activity) {
      <li href="#" class="list-group-item list-group-item-action flex-column align-items-start"  [ngClass]="{'snapshot-text': isDiscussionContent}">
        @if (activity) {
          <ebs-reply [isDiscussionContent]="isDiscussionContent" [truncateContentLength]="truncateContentLength" [courseCode]="courseCode" [activity]="activity" [isFaculty]="isFaculty"></ebs-reply>
        }
      </li>
    }
  </ul>
}
